/* eslint-disable */
import store from '@/store';

export const waitForFirebaseInitialized = () => {
  return new Promise((resolve) => {
    const check = () => {
      if (store.state.app.firebaseInitialized || !store.getters['user/isLoggedIn']) {
        resolve();
      } else {
        setTimeout(check, 200);
      }
    };
    check();
  });
};


export const waitForStatusReady = () => {
  return new Promise((resolve) => {
    const check = () => {
      if (typeof store.state.user.status.hasBeenFunded !== 'undefined') {
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
};



// WEBPACK FOOTER //
// ./src/utils/mutex.js